/*
  Seção HALO Guia ferramenta (sections/halo-guia-ferramenta.liquid).

  O assets/size-guide.js avisa cada medida com o evento halo:medida (circunferência digitada ou
  diâmetro do anel na tela). Este script compara com os tamanhos da página (window.haloSizes,
  montado pelo size-guide.js a partir da seção HALO Tabela de tamanhos) e mostra:
  - o tamanho exato, se a medida cai na margem de um tamanho da tabela;
  - entre dois tamanhos: recomenda o menor;
  - fora da tabela: o aviso para medir de novo.
  O botão de compra abre o produto com a variante desse tamanho (?variant=...&tamanho=9); o
  assets/halo-seletor.js da página do produto já marca o tamanho como escolhido.
  Botões com data-halo-aba (ex.: "Calibrar agora" na seção HALO Cartões) rolam até a ferramenta e
  abrem a aba. No celular, a barra fixa de compra aparece depois que a ferramenta sai da tela.
*/
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 767px)');
  var current = null;
  // Separador decimal do idioma da página: vírgula em português, ponto nos outros.
  var DECIMAL = /^pt/i.test(document.documentElement.lang || '') ? ',' : '.';

  function root() {
    return document.querySelector('[data-halo-guia]');
  }

  function fill(text, size, other) {
    return String(text || '')
      .split('[tamanho]').join(size.s)
      .split('[br]').join(size.br)
      .split('[circunferencia]').join(String(size.c).replace(/[.,]/, DECIMAL))
      .split('[menor]').join(size.s)
      .split('[maior]').join(other ? other.s : '');
  }

  function sizes() {
    var list = (window.haloSizes || []).slice();
    list.sort(function (a, b) { return a.c - b.c; });
    return list;
  }

  // Circunferência medida em mm: tamanho exato, entre dois tamanhos ou fora da tabela.
  function classify(c, list, margin) {
    if (!list.length) return null;
    var first = list[0];
    var last = list[list.length - 1];
    if (c < first.c - margin || c > last.c + margin) return { state: 'fora' };
    var best = null;
    var bestDiff = Infinity;
    for (var i = 0; i < list.length; i++) {
      var diff = Math.abs(list[i].c - c);
      if (diff <= margin && diff < bestDiff) {
        best = list[i];
        bestDiff = diff;
      }
    }
    if (best) return { state: 'ok', size: best };
    for (var j = 0; j < list.length - 1; j++) {
      if (c > list[j].c && c < list[j + 1].c) return { state: 'ok', size: list[j], bigger: list[j + 1] };
    }
    return { state: 'fora' };
  }

  function variantUrl(el, size) {
    var base = el.dataset.produtoUrl;
    if (!base) return null;
    var data = el.querySelector('[data-halo-variantes]');
    var list = [];
    try { list = data ? JSON.parse(data.textContent) : []; } catch (e) { list = []; }
    var match = null;
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].tamanho) !== String(size.s)) continue;
      if (list[i].disponivel) { match = list[i]; break; }
      if (!match) match = list[i];
    }
    if (!match) return base;
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + match.id + '&tamanho=' + encodeURIComponent(size.s);
  }

  function highlightTable(size) {
    document.querySelectorAll('[data-halo-tabela] [data-tamanho]').forEach(function (row) {
      row.classList.toggle('is-resultado', !!size && row.dataset.tamanho === String(size.s));
    });
  }

  function render(el, result) {
    var ok = el.querySelector('[data-estado="ok"]');
    var out = el.querySelector('[data-estado="fora"]');
    current = result && result.state === 'ok' ? result.size : null;

    if (ok) ok.hidden = !result || result.state !== 'ok';
    if (out) out.hidden = !result || result.state !== 'fora';
    highlightTable(current);
    updateBar(el);
    if (!result || result.state !== 'ok' || !ok) return;

    var size = result.size;
    ok.querySelector('[data-numero]').textContent = size.s;
    ok.querySelector('[data-detalhe]').textContent = fill(el.dataset.txtDetalhe, size);
    var between = ok.querySelector('[data-entre]');
    between.hidden = !result.bigger;
    between.textContent = result.bigger ? fill(el.dataset.txtEntre, size, result.bigger) : '';
    var buy = ok.querySelector('[data-comprar]');
    if (buy) {
      buy.querySelector('[data-comprar-texto]').textContent = fill(el.dataset.txtComprar, size);
      buy.href = variantUrl(el, size) || buy.href;
    }
  }

  function onMeasure(e) {
    var el = root();
    if (!el || !e.detail) return;
    var value = e.detail.valor;
    if (value === null || value === undefined || isNaN(value)) {
      render(el, null);
      return;
    }
    var c = e.detail.tipo === 'diam' ? value * Math.PI : value;
    var margin = parseFloat(el.dataset.margem) || 0.8;
    render(el, classify(c, sizes(), margin));
  }

  // Barra fixa no celular
  var toolVisible = true;
  var toolAbove = false;
  var footerVisible = false;

  function updateBar(el) {
    var bar = el.querySelector('[data-barra]');
    if (!bar) return;
    var link = bar.querySelector('[data-barra-link]');
    if (current) {
      link.textContent = fill(el.dataset.txtBarraTamanho, current);
      link.href = variantUrl(el, current) || link.href;
    } else {
      link.textContent = el.dataset.txtBarra;
      link.href = el.dataset.produtoUrl || link.href;
    }
    var show = mobile.matches && !toolVisible && toolAbove && !footerVisible;
    bar.classList.toggle('is-visivel', show);
    bar.setAttribute('aria-hidden', String(!show));
    link.tabIndex = show ? 0 : -1;
  }

  var observers = [];

  function watchBar(el) {
    var bar = el.querySelector('[data-barra]');
    if (!bar || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var tool = el.querySelector('.halo-guia-ferramenta__inner') || el;
    var toolObs = new IntersectionObserver(function (entries) {
      toolVisible = entries[0].isIntersecting;
      toolAbove = entries[0].boundingClientRect.top < 0;
      updateBar(el);
    });
    toolObs.observe(tool);
    observers.push(toolObs);

    var footer = document.querySelector('.shopify-section-group-footer-group');
    if (footer) {
      var footObs = new IntersectionObserver(function (entries) {
        footerVisible = entries.some(function (entry) { return entry.isIntersecting; });
        updateBar(el);
      });
      document.querySelectorAll('.shopify-section-group-footer-group').forEach(function (f) { footObs.observe(f); });
      observers.push(footObs);
    }
  }

  // Botões que abrem uma aba da ferramenta (data-halo-aba = 0 tabela, 1 calibrar, 2 sua medida)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest && e.target.closest('[data-halo-aba]');
    if (!trigger) return;
    var el = root();
    if (!el) return;
    e.preventDefault();
    var tab = parseInt(trigger.dataset.haloAba, 10) || 0;
    if (typeof window.haloPT === 'function') window.haloPT(tab);
    el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    var button = el.querySelector('.halo-mt[data-tab="' + tab + '"]');
    if (button) button.focus({ preventScroll: true });
  });

  document.addEventListener('halo:medida', onMeasure);

  function init() {
    var el = root();
    if (!el) return;
    toolVisible = true;
    toolAbove = false;
    footerVisible = false;
    watchBar(el);
    updateBar(el);
  }

  function teardown() {
    observers.forEach(function (o) { o.disconnect(); });
    observers = [];
    current = null;
  }

  if (mobile.addEventListener) {
    mobile.addEventListener('change', function () {
      var el = root();
      if (el) updateBar(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target.querySelector('[data-halo-guia]')) return;
    teardown();
    init();
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.querySelector('[data-halo-guia]')) teardown();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var el = root();
    if (el && e.target.closest && e.target.closest('[data-halo-guia]')) el.scrollIntoView({ block: 'start' });
  });
})();
